import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { Profile } from '../models/profile';

@Injectable()
export class ProfileHttpService {

  constructor(
    private urlBuilder: UrlBuilderService,
    private http: HttpClient) {
  }

  getAll(product: string): Observable<Profile[]> {
    const url = this.urlBuilder.getUrl('profiles');
    const params = new HttpParams().set('product', product);
    return this.http
      .get<Profile[]>(url, { params: params }).pipe(
        map(p => p || [])
      );
  }

  isNameAvailable(profileName: string, product: string): Observable<boolean> {
    const profileNameAvailableUrl = this.urlBuilder.getUrl('profiles/available');
    let params = new HttpParams().set('profileName', profileName);
    params = params.set('product', product);

    return this
      .http
      .get<boolean>(profileNameAvailableUrl, { params: params });
  }

  createProfile(profile: Profile): Observable<string> {
    const profileAddUrl = this.urlBuilder.getUrl('profiles/add');

    const result = this
      .http
      .post(profileAddUrl, profile, { responseType: 'text' });

    return result;
  }

  updateProfile(profile: Profile): Observable<string> {
    const profileAddUrl = this.urlBuilder.getUrl('profiles/update');

    const result = this
      .http
      .post(profileAddUrl, profile, { responseType: 'text' });

    return result;
  }

  deleteProfile(id: number): Observable<Object> {
    const url = this.urlBuilder.getUrl('profile') + `?id=${id}`;
    return this.http.delete(url);
  }

  createcopy(profile: Profile): Observable<string> {
    const url = this.urlBuilder.getUrl('profiles/createcopy');

    const result = this
      .http
      .post(url, profile, { responseType: 'text' });

    return result;
  }

  associateProfileWithClient(clientRef: number, profileId: number): Observable<string> {
    const url = this.urlBuilder.getUrl('profiles/associateProfileWithClient');

    const result = this
      .http
      .post(url, { ProfileId: profileId, Ref: clientRef }, { responseType: 'text' });

    return result;
  }
  associateProfileWithClientParent(clientParentId: number, profileId: number): Observable<string> {
    const url = this.urlBuilder.getUrl('profiles/associateProfileWithClientParent');

    const result = this
      .http
      .post(url, { ProfileId: profileId, Ref: clientParentId }, { responseType: 'text' });

    return result;
    }

  associateProfileWithSupplier(supplierRef: number, profileId: number): Observable<string> {
      const url = this.urlBuilder.getUrl('profiles/associateProfileWithSupplier');

    const result = this
      .http
        .post(url, { ProfileId: profileId, Ref: supplierRef }, { responseType: 'text' });

    return result;
    }

  associateProfileWithCreditor(creditorRef: number, profileId: number): Observable<string> {
      const url = this.urlBuilder.getUrl('profiles/associateProfileWithCreditor');

    const result = this
      .http
        .post(url, { ProfileId: profileId, Ref: creditorRef }, { responseType: 'text' });

    return result;
  }
}
